export default "__VITE_ASSET__CGImxecp__"